<template>
	<div class="layout-menu-container">
		<AppSubmenu :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" :alertas="alertas" :pendientes="pendientes" />
	</div>
</template>

<script>
import AppSubmenu from './AppSubmenu';
import AlertasService from './service/AlertasService'

export default {
	props: {
		model: Array
	},
	data() {
		return {
			leerAlertasTimer: null,
			alertas: {
				solicitudes: 0,
				vencimientos_documentacion_clientes: 0,
				vencimientos_documentacion_proveedores: 0,
				vencimientos_documentacion_usuarios: 0,
				ingresar_documentacion: 0,
			},
			pendientes: {
				validar_documentacion_clientes: 0,
				validar_documentacion_proveedores: 0,
				validar_documentacion_usuarios: 0,
				mensajes: 0,
			},
		}
	},
	methods: {
		onMenuItemClick(event) {
			this.$emit('menuitem-click', event);
		},
		async leerAlertas() {
			const respuesta = await AlertasService.get()

			if (respuesta.success === true) {
				this.alertas.solicitudes = respuesta.alertas.solicitudes.cantidad;
				this.alertas.vencimientos_documentacion_clientes = respuesta.alertas.vencimientos_documentacion_clientes.cantidad;
				this.alertas.vencimientos_documentacion_proveedores = respuesta.alertas.vencimientos_documentacion_proveedores.cantidad;
				this.alertas.vencimientos_documentacion_usuarios = respuesta.alertas.vencimientos_documentacion_usuarios.cantidad;
				this.alertas.ingresar_documentacion = respuesta.alertas.ingresar_documentacion.cantidad;

				this.pendientes.validar_documentacion_clientes = respuesta.pendientes.validar_documentacion_clientes.cantidad;
				this.pendientes.validar_documentacion_proveedores = respuesta.pendientes.validar_documentacion_proveedores.cantidad;
				this.pendientes.validar_documentacion_usuarios = respuesta.pendientes.validar_documentacion_usuarios.cantidad;
				this.pendientes.mensajes = respuesta.pendientes.mensajes.cantidad;
			}

			this.leerAlertasTimer = setTimeout(() => {
				this.leerAlertas()
			}, 15000)
		}
	},
	async mounted() {
		await this.leerAlertas();
	},
	unmounted() {
		clearInterval(this.leerAlertasTimer)
	},
	components: {
		'AppSubmenu': AppSubmenu
	}
}
</script>

<style scoped>
</style>